const RevenueSpendByAccountSpendDetailsTableLangKey = [
	'column_id',
	'column_date',
	'column_amount',
	'column_percent',
	'column_account',
	'column_kt_group',
	'column_agency',
	'column_fake_type'
] as const

type IRevenueSpendByAccountSpendDetailsTableLangKey = typeof RevenueSpendByAccountSpendDetailsTableLangKey[number]

export type IRevenueSpendByAccountSpendDetailsTableLang = {
	revenue_spend_by_account_spend_details_table: Record<IRevenueSpendByAccountSpendDetailsTableLangKey, string>
}

const langEntries = RevenueSpendByAccountSpendDetailsTableLangKey.map(
	(key: IRevenueSpendByAccountSpendDetailsTableLangKey) => [key, `revenue_spend_by_account_spend_details_table.${key}`]
)

const langObj: Record<IRevenueSpendByAccountSpendDetailsTableLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_BY_ACCOUNT_SPEND_DETAILS_TABLE_LANG_KEY: IRevenueSpendByAccountSpendDetailsTableLang = {
	revenue_spend_by_account_spend_details_table: langObj
}
